'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.minutes;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/minutes.js
// module id = 708
// module chunks = 0